import Vidita from '../assets/brand/Vidita'
import ArrowRightIcon from '../assets/icons/ArrowRightIcon'

const WorkWithUs = () => {
  return (
    <section className="WorkWithUs container-fluid">
      <div className="WorkWithUs__Container container-custom">
        <div className="WorkWithUs__Card">
          <h3>¿Querés ser parte de VIDA?</h3>
          <p>¡Hacé click en el botón y contanos de vos!</p>
          <a
            className="Home-Contact__Submit button-new-orange"
            href='https://forms.gle/KywyPL7bJK5ihEs77'
            target='_blank'
            rel="noreferrer"
          >
            Enviar CV
            <ArrowRightIcon width={20} height={20}/>
          </a>
        </div>
      </div>
    </section>
  )
}

export default WorkWithUs